<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Ближайшие игры</b-card-title>
      <b-badge variant="light-primary">{{ games.length }}</b-badge>
    </b-card-header>
    <b-card-body class="pt-0">
      <div v-if="!games.length" class="text-muted py-2">Записей на ближайшие дни нет</div>
      <div v-for="group in groups" :key="group.title" class="mb-1">
        <small class="text-uppercase text-muted font-weight-bold">{{ group.title }}</small>
        <div v-for="game in group.games" :key="game.task_id" class="d-flex align-items-start py-50 border-bottom">
          <div class="mr-1 text-nowrap font-weight-bold" style="min-width: 3.5rem">{{ formatTime(game.start_datetime) }}</div>
          <div class="flex-grow-1">
            <div>{{ game.topic }} <span v-if="game.pack_name" class="text-muted">· {{ game.pack_name }}</span></div>
            <small class="text-muted">{{ game.host || 'ведущий не назначен' }}</small>
          </div>
          <div class="text-right text-nowrap">
            <b-badge :variant="placesVariant(game)">{{ game.count }}/{{ game.max_players }}</b-badge>
            <div>
              <b-link v-if="game.post_url" :href="game.post_url" target="_blank" rel="noopener noreferrer" class="font-small-2">пост</b-link>
              <b-link :href="game.task_url" target="_blank" rel="noopener noreferrer" class="font-small-2 ml-50">задача</b-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="premiere" class="mt-1 p-1 rounded bg-light-primary">
        <small class="text-uppercase text-muted font-weight-bold">Ближайшая премьера</small>
        <div class="font-weight-bold">{{ premiere.pack_name }}</div>
        <small class="text-muted">
          {{ premiere.topic }}<span v-if="premiere.author"> · {{ premiere.author }}</span>
          · {{ formatDate(premiere.premiere_date) }} ({{ daysLeftLabel(premiere.days_left) }})
        </small>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BLink,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatDate } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BLink,
  },
  props: {
    upcoming: { type: Object, default: null },
  },
  setup(props) {
    const games = computed(() => (props.upcoming && props.upcoming.games) || [])
    const premiere = computed(() => (props.upcoming && props.upcoming.next_premiere) || null)

    const dayKey = iso => new Date(iso).toDateString()
    const groups = computed(() => {
      const today = new Date()
      const tomorrow = new Date(today.getTime() + 86400000)
      const buckets = { today: [], tomorrow: [], later: [] }
      games.value.forEach(game => {
        const key = dayKey(game.start_datetime)
        if (key === today.toDateString()) buckets.today.push(game)
        else if (key === tomorrow.toDateString()) buckets.tomorrow.push(game)
        else buckets.later.push(game)
      })
      return [
        { title: 'Сегодня', games: buckets.today },
        { title: 'Завтра', games: buckets.tomorrow },
        { title: 'Позже', games: buckets.later },
      ].filter(group => group.games.length)
    })

    const formatTime = iso => new Date(iso).toLocaleString('ru-RU', { weekday: 'short', hour: '2-digit', minute: '2-digit' })

    // Красный — кворума (3) ещё нет, жёлтый — есть места, зелёный — полный состав
    const placesVariant = game => {
      if (game.is_full) return 'success'
      return game.count >= 3 ? 'warning' : 'danger'
    }

    const daysLeftLabel = days => {
      if (days === 0) return 'сегодня'
      if (days === 1) return 'завтра'
      return `через ${days} дн.`
    }

    return {
      games, premiere, groups, formatTime, placesVariant, daysLeftLabel, formatDate,
    }
  },
}
</script>
